import React, { createRef, PureComponent } from 'react';
import { Link, withRouter, RouteComponentProps, NavLink } from 'react-router-dom';
import autobind from 'autobind-decorator';
import config, { getPageTitleByPath, MenuConfig } from './config';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import './index.less';
import Store from 'redux/type';
import Common, { UserInfo } from 'redux/common/type';
import { Dropdown, Menu } from 'm-ui';
import { Down } from '@icon-park/react';
import NewIcon from '../../component/NewIcon';

type IMenuProps = RouteComponentProps & {
    userInfo: UserInfo;
    common: Common;
};

const allowUserType = 'INTERNAL_CIRCULATION';
class MenuTop extends PureComponent<IMenuProps, any> {
    state = {
        checked: '',
        targetLink: null,
        confirmed: false,
        indicateOffset: -40,
    };

    menuRef = createRef<HTMLDivElement>();

    componentDidMount() {
        this.setChecked();

        const { pathname, search } = this.props.location;
        const title = getPageTitleByPath(`${pathname}${search}`, config);
        if (title) {
            document.title = title;
        }
        window.addEventListener('resize', this.handleResizeThrottled);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setChecked();
            const { pathname, search } = this.props.location;
            const title = getPageTitleByPath(`${pathname}${search}`, config);
            if (title) {
                document.title = title;
            }
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.handleResizeThrottled);
    }

    @autobind
    moveIndicate(path: string) {
        const domRect = this.menuRef.current.getBoundingClientRect();
        const activeDom = document.getElementById(`menu-top${path}`);
        if (activeDom) {
            const activeRect = activeDom.getBoundingClientRect();
            this.setState({
                indicateOffset: activeRect.x - domRect.x + activeRect.width / 2 - 16,
            });
        } else {
            // 找不到就隐藏
            this.setState({
                indicateOffset: -40,
            });
        }
    }

    handleResize = () => {
        const conf = this.getConfByPathname(this.props.location?.pathname);
        this.moveIndicate(conf?.path);
    };

    handleResizeThrottled = throttle(this.handleResize, 200);

    render() {
        const { checked, indicateOffset } = this.state;
        const { userInfo, common } = this.props;

        return (
            <div className="menu-top" ref={this.menuRef}>
                <i
                    className="indicate"
                    style={{
                        left: indicateOffset,
                    }}
                />
                {config
                    .filter(
                        (item) =>
                            !item.filter ||
                            item.filter({ ...userInfo, ...common?.authorizeAndType }),
                    )
                    ?.filter((item) => {
                        if (common?.authorizeAndType?.authorize === false) {
                            return item?.title !== '人群优化';
                        }
                        return item;
                    })
                    ?.map((conf) => (
                        <Dropdown
                            overlay={
                                conf.children && (
                                    <Menu className="menu-top-children">
                                        {conf.children
                                            .filter(
                                                (item) =>
                                                    !item.filter ||
                                                    item.filter({
                                                        ...userInfo,
                                                        ...common?.authorizeAndType,
                                                    }),
                                            )
                                            .map((conf) => (
                                                <Menu.Item
                                                    className={`menu-top-children-item ${
                                                        conf.path === checked
                                                            ? 'menu-top-children-item_active'
                                                            : ''
                                                    }`}
                                                    key={conf.path + conf.title}
                                                    onClick={() => this.handleClick(conf)}
                                                >
                                                    {conf.path && !conf.path.startsWith('//') ? (
                                                        <NavLink to={conf.path}>
                                                            {conf.title}
                                                        </NavLink>
                                                    ) : (
                                                        <a
                                                            href={conf.path || '#'}
                                                            target={conf.path ? '_blank' : '_self'}
                                                        >
                                                            {conf.title}
                                                        </a>
                                                    )}
                                                </Menu.Item>
                                            ))}
                                    </Menu>
                                )
                            }
                            disabled={!conf.children}
                            key={conf.path + conf.title}
                        >
                            <div
                                id={'menu-top' + conf.path}
                                className={`menu-top__item ${
                                    conf.path === checked ? 'menu-top__item_active' : ''
                                }`}
                                onClick={() => this.handleClick(conf)}
                            >
                                {conf.path && !conf.path.startsWith('//') ? (
                                    <Link
                                        to={
                                            conf.filterFunc
                                                ? conf.filterFunc({
                                                      ...userInfo,
                                                      ...common?.authorizeAndType,
                                                  })
                                                : conf.path
                                        }
                                    >
                                        {conf.title}
                                    </Link>
                                ) : (
                                    <NavLink
                                        to={
                                            conf.filterFunc
                                                ? conf.filterFunc({
                                                      ...userInfo,
                                                      ...common?.authorizeAndType,
                                                  })
                                                : conf.path || '#'
                                        }
                                        target={
                                            conf.filterFunc
                                                ? conf.filterFunc({
                                                      ...userInfo,
                                                      ...common?.authorizeAndType,
                                                  })
                                                : conf.path
                                                ? '_blank'
                                                : '_self'
                                        }
                                    >
                                        {conf.title}
                                    </NavLink>
                                )}
                                {conf.children && (
                                    <span className="menu-top__arrow">
                                        <Down theme="outline" size="16" fill="#8c8c8c" />
                                    </span>
                                )}
                                {conf.showNewIcon && conf.releaseDate && (
                                    <NewIcon
                                        className="menu-top__newicon"
                                        isVisible={conf.showNewIcon(conf.releaseDate)}
                                        type="icon-chinese"
                                    />
                                )}
                            </div>
                        </Dropdown>
                    ))}
            </div>
        );
    }

    setChecked() {
        const conf = this.getConfByPathname(this.props.location.pathname);
        if (conf && conf.path) {
            this.setState({
                checked: conf.path,
            });
            this.moveIndicate(conf.path);
        }
    }

    getConfByPathname(pathname: string, configs?: MenuConfig[]): null | MenuConfig {
        configs = configs || config;
        for (let i = 0; i < configs.length; i++) {
            if (configs[i].path === pathname) {
                return configs[i];
            } else if (configs[i].includes?.includes(pathname)) {
                return configs[i];
            }
            if (configs[i].children) {
                const findConf = this.getConfByPathname(pathname, configs[i].children);
                if (findConf) {
                    return findConf;
                }
            }
        }
        return null;
    }

    @autobind
    handleClick(conf) {
        const { userInfo } = this.props;
        if (conf.children) {
            this.setState({});
        }
        if (conf.path) {
            this.setState({
                checked: conf.filterFunc ? conf.filterFunc(userInfo) : conf.path,
            });
        }
    }
}

export default connect((state: Store) => ({
    userInfo: state.common.userInfo,
    common: state.common,
}))(withRouter(MenuTop));
